import { useUpcomingPayment, } from "../hooks";
import { UpcomingPaymentBlockView, } from "./UpcomingPaymentBlockView.tsx";

export function UpcomingPaymentBlockDefault() {
  const { upcomingPayments, } = useUpcomingPayment();

  return (
    <UpcomingPaymentBlockView
      isLoading={upcomingPayments.isLoading}
      isSuccess={upcomingPayments.isSuccess}
      data={upcomingPayments.data ?? []}
    />
  );
}
